import { render, staticRenderFns } from "./behavior-section.vue?vue&type=template&id=633ed3f2&scoped=true&"
import script from "./behavior-section.vue?vue&type=script&lang=js&"
export * from "./behavior-section.vue?vue&type=script&lang=js&"
import style0 from "./behavior-section.vue?vue&type=style&index=0&id=633ed3f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633ed3f2",
  null
  
)

export default component.exports